import { SelectField } from './SelectField';

/**
 * A locale is a language against a market. Each market's own language comes
 * first, then English against every one of them — merchants selling
 * cross-border serve English copy into markets that are not Great Britain, and
 * that combination is worth being able to look at.
 */
const LOCALES = [
  'da-DK',
  'de-DE',
  'en-GB',
  'es-ES',
  'fi-FI',
  'fr-FR',
  'it-IT',
  'nb-NO',
  'nl-NL',
  'no-NO',
  'pl-PL',
  'pt-PT',
  'sv-SE',

  'en-DE',
  'en-DK',
  'en-ES',
  'en-FI',
  'en-FR',
  'en-IT',
  'en-NL',
  'en-NO',
  'en-PL',
  'en-PT',
  'en-SE',
] as const;

/**
 * The backend takes any ISO 4217 code, so this is a shortlist rather than a
 * limit: the currencies of the locales above, plus the two most likely to come
 * up next.
 */
const CURRENCIES = [
  'SEK',
  'NOK',
  'DKK',
  'EUR',
  'GBP',
  'PLN',
  'CHF',
  'USD',
] as const;

interface OtherConfigValues {
  locale: string;
  currency: string;
}

interface OtherConfigProps extends OtherConfigValues {
  name: string;
  onChange: (values: OtherConfigValues) => void;
}

export function OtherConfig({
  name,
  locale,
  currency,
  onChange,
}: OtherConfigProps) {
  return (
    <div className="flex w-full flex-col gap-4">
      <SelectField
        id={`${name}-locale`}
        label="Locale"
        value={locale}
        options={LOCALES}
        onChange={(value) => onChange({ currency, locale: value })}
      />

      <SelectField
        id={`${name}-currency`}
        label="Currency"
        value={currency}
        options={CURRENCIES}
        onChange={(value) => onChange({ locale, currency: value })}
      />
    </div>
  );
}
